import { render, staticRenderFns } from "./Circuits.vue?vue&type=template&id=2add0f51&scoped=true&"
import script from "./Circuits.vue?vue&type=script&lang=ts&"
export * from "./Circuits.vue?vue&type=script&lang=ts&"
import style0 from "./Circuits.vue?vue&type=style&index=0&id=2add0f51&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add0f51",
  null
  
)

export default component.exports